<template>
  <div class="enter-code">

    <div class="title">
      <div v-if="firstName">היי {{ firstName }},</div>
      <div>מה הקוד שקיבלת?</div>
    </div>

    <div class="sent-you">
      <div class="whatsapp">שלחנו לך קוד ב-WhatsApp למספר</div>
      <span class="bold">{{phoneNumber}}.</span>
      <span class="question">מה הקוד שמופיע בו?</span>
    </div>

    <text-input
      :autofocus="true"
      :labelText="'קוד 6 ספרות'"
      :value="code"
      :onInput="onInput"
      :error="error"
      :inputType="'number'"
      :inputPattern="'\\d*'"
      :topLeftLabel="errorLabel"/>

    <riseup-button :title="buttonTitle" :action="() => confirmCodeAction(code)" :loading="loading" :disabled="buttonDisabled"/>

    <div class="action" v-on:click="sendCodeAgain" v-if="!sendAgainLoading">לא קיבלתי את הקוד, שלחו לי שוב</div>
    <div class="loader" v-else/>

  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../Segment';

const ERRORS = {
  CODE_EXPIRED: 'CODE_EXPIRED',
  INVALID_CODE: 'INVALID_CODE',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
};

export default {
  name: 'EnterCode',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    TextInput: BaseUI.TextInput,
  },
  props: {
    firstName: {
      type: String,
      required: false,
    },
    phoneNumber: {
      type: String,
      required: true,
    },
    confirmCodeAction: {
      type: Function,
      required: true,
    },
    regenerateCodeAction: {
      type: Function,
      required: true,
    },
    serverError: {
      type: String,
      required: true,
    },
    resetError: {
      type: Function,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      code: '',
      sendAgainLoading: false,
      triedAutoConfirm: false,
    };
  },
  computed: {
    buttonDisabled() {
      return this.code.length !== 6 || this.loading;
    },
    codeContainsOnlyNumbers() {
      return /^([0-9]*)$/.test(this.code);
    },
    error() {
      return !!this.serverError || !this.codeContainsOnlyNumbers;
    },
    errorLabel() {
      if (this.serverError === ERRORS.CODE_EXPIRED) {
        Segment.trackUserGot('expiredCodeError');
        return 'הקוד פג תוקף';
      } if (this.serverError === ERRORS.INVALID_CODE) {
        Segment.trackUserGot('invalidCodeError', { invalidCode: this.code });
        return 'הקוד שהזנת לא תקין';
      } if (!this.codeContainsOnlyNumbers) {
        return 'הקוד צריך להכיל ספרות בלבד';
      } if (this.serverError === ERRORS.UNKNOWN_ERROR) {
        return 'נראה שקרתה תקלה, נסו שוב בהמשך';
      }
      return null;
    },
  },
  methods: {
    onInput(value) {
      this.code = value;
      this.resetError();
      if (!this.triedAutoConfirm && this.code.length === 6) {
        this.triedAutoConfirm = true;
        this.confirmCodeAction(this.code);
      }
    },
    async sendCodeAgain() {
      this.sendAgainLoading = true;
      await this.regenerateCodeAction();
      this.sendAgainLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../scss/mixins';

  .enter-code {

    .title {
      padding: 20px 0px;
      font-family: GretaSans;
      font-size: 28px;
      line-height: 28px;
    }

    .sent-you {
      margin-bottom: 42px;
      font-size: 18px;
      line-height: 18px;

      .whatsapp {
        margin-bottom: 10px;
      }

      .bold {
        font-weight: bold;
      }

      .question {
        padding: 12px 0px;
      }
    }

    .riseup-button {
      width: 100%;
      margin: 10px 0px;
    }

    .action {
      margin: 20px 0px;
      color: $riseup_light_blue;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
      font-size: 16px;
      text-align: center;
    }

    .loader {
      margin: 0 auto;
      width: 34px;
      height: 34px;
      border: 4px solid $riseup_light_blue;
      border-top: 4px solid $riseup_white;
      border-radius: 50%;
      animation: spin 2s linear infinite;

      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    }
  }
</style>
